export default [
  // {
  //   title: 'Главная',
  //   route: 'admin-home',
  //   icon: 'HomeIcon',
  //   resource: 'AdminHome',
  //   action: 'read',
  // },
  {
    title: 'Заказы',
    icon: 'ArchiveIcon',
    route: 'admin-orders-list',
    resource: 'Orders',
    action: 'read',
  },
  {
    title: 'Отчет о пакетах',
    icon: 'PieChartIcon',
    route: 'admin-report',
    resource: '*',
    // resource: 'Report',
    action: 'read',
  },
  {
    title: 'Пользователы',
    icon: 'UserIcon',
    route: 'admin-users-list',
    resource: 'Users',
    action: 'read',
  },
  {
    title: 'Список меню',
    route: 'menus',
    icon: 'ListIcon',
    resource: 'Menus',
    action: 'read',
  },
  {
    title: 'Список слайдеров',
    route: 'slider',
    icon: 'FileIcon',
    resource: 'Sliders',
    action: 'read',
  },
]
